import { ACTION, Question, QUESTION_TYPE } from "containers/Survey/types"
import { cdn } from "core/cdn"
import { LENS_PAGE, TUTORIAL_OPTIC_PAGE } from "core/constants"
import { languages } from "lib/languages"

import { PATH } from "./_paths"
import { booleanSubReplies } from "./questions"

export const contact_lens_diameter: Question = {
  title: languages.contactLensDiameter,
  id: PATH.contact_lens_diameter,
  multipleReplies: false,
  keyboard: { type: "code", decimalScale: 1, unit: "mm" },
  replies: [],
  type: QUESTION_TYPE.redirect,
  value: LENS_PAGE,
}

export const contact_lens_bending_radius: Question = {
  title: languages.contactLensBendingRadius,
  id: PATH.contact_lens_bending_radius,
  multipleReplies: false,
  keyboard: { type: "code", decimalScale: 1, unit: "mm" },
  subquestion: contact_lens_diameter,
  replies: [],
  type: QUESTION_TYPE.redirect,
  value: LENS_PAGE,
}

export const contact_lens_brand: Question = {
  title: languages.contactLensBrand,
  id: PATH.contact_lens_brand,
  multipleReplies: false,
  subquestion: contact_lens_bending_radius,
  replies: [
    {
      title: "ALCON",
      value: "ALCON",
      imgUrl: cdn("images/lens_brands/alcon.svg"),
      action: ACTION.subquestion,
    },
    {
      title: "BAUSCH + LOMB",
      value: "BAUSCH + LOMB",
      imgUrl: cdn("images/lens_brands/bauschlomb.svg"),
      action: ACTION.subquestion,
    },
    {
      title: "CooperVision",
      value: "CooperVision",
      imgUrl: cdn("images/lens_brands/coopervision.svg"),
      action: ACTION.subquestion,
    },
    {
      title: "CVE",
      value: "CVE",
      imgUrl: cdn("images/lens_brands/cve.svg"),
      action: ACTION.subquestion,
    },
    {
      title: "Johnson & Johnson",
      value: "Johnson & Johnson",
      imgUrl: cdn("images/lens_brands/johnson.svg"),
      action: ACTION.subquestion,
    },
    {
      title: "MENICON",
      value: "MENICON",
      imgUrl: cdn("images/lens_brands/menicon.svg"),
      action: ACTION.subquestion,
    },
    {
      title: "Mark’ennovy",
      value: "Mark’ennovy",
      imgUrl: cdn("images/lens_brands/markennovy.svg"),
      action: ACTION.subquestion,
    },
    {
      title: "NOVACEL",
      value: "NOVACEL",
      imgUrl: cdn("images/lens_brands/novacel.svg"),
      action: ACTION.subquestion,
    },
    {
      title: "OPHTALMIC",
      value: "OPHTALMIC",
      imgUrl: cdn("images/lens_brands/ophtalmic.svg"),
      action: ACTION.subquestion,
    },
    {
      title: "Precilens",
      value: "Precilens",
      imgUrl: cdn("images/lens_brands/precilens.svg"),
      action: ACTION.subquestion,
    },
    {
      title: "Autres",
      value: "Autre",
      imgUrl: cdn("images/lens_brands/other.svg"),
      action: ACTION.subquestion,
    }
  ],
}
export const contact_lens_type: Question = {
  title: languages.contactLensType,
  id: PATH.contact_lens_type,
  multipleReplies: false,
  subquestion: contact_lens_brand,
  replies: [
    {
      title: languages.contactLensDaily,
      value: languages.contactLensDaily,
      action: ACTION.subquestion,
    },
    {
      title: languages.contactLensMonthly,
      value: languages.contactLensMonthly,
      action: ACTION.subquestion,
    },
    {
      title: languages.contactLensBiMonthly,
      value: languages.contactLensBiMonthly,
      action: ACTION.subquestion,
    },
  ],
}
export const reason_details: Question = {
  title: languages.WhenWasThelastConsultation,
  id: PATH.reason_details,
  subquestion: contact_lens_type,
  replies: [
    {
      title: languages.lessThanAYear,
      value: languages.lessThanAYear.toLowerCase(),
      action: ACTION.subquestion,
    },
    {
      title: languages.moreThanAYear,
      value: languages.moreThanAYear.toLowerCase(),
      action: ACTION.subquestion,
    },
  ],
}
export const reason: Question = {
  title: languages.anamneseReasonQuestion,
  id: PATH.reason,
  multipleReplies: false,
  // ui: { view: "carousel" },
  subquestion: reason_details,
  replies: [
    {
      title: languages.glassesRenewal,
      value: languages.glassesRenewal,
      imgUrl: cdn("/images/optic/reasons/picto_glasses_renewal.svg"),
      action: ACTION.subquestion,
    },
    {
      title: languages.lensesRenewal,
      value: languages.lensesRenewal,
      imgUrl: cdn("/images/optic/reasons/picto_lenses_renewal.svg"),
      action: ACTION.subquestion,
    },
    {
      title: languages.firstConsultation,
      value: languages.firstConsultation,
      imgUrl: cdn("/images/optic/reasons/picto_first_consultation.svg"),
    },
  ],
}
export const optic_illness_details: Question = {
  title: languages.anamneseOphtalmologicBackgroundQuestionDetails,
  id: PATH.optic_illness_details,
  multipleReplies: true,
  replies: [
    {
      title: languages.glaucoma,
      value: languages.glaucoma,
      imgUrl: cdn("/images/optic_illnesses/picto_glaucoma.svg"),
    },
    {
      title: languages.DMLA,
      value: languages.DMLA,
      imgUrl: cdn("/images/optic_illnesses/picto_DMLA.svg"),
    },
    {
      title: languages.strabismus,
      value: languages.strabismus,
      imgUrl: cdn("/images/optic_illnesses/picto_strabismus.svg"),
    },
    {
      title: languages.keratoconus,
      value: languages.keratoconus,
      imgUrl: cdn("/images/optic_illnesses/picto_keratoconus.svg"),
    },
    {
      title: languages.cataract,
      value: languages.cataract,
      imgUrl: cdn("/images/optic_illnesses/picto_cataract.svg"),
    },
    {
      title: languages.otherOphtalmologicDisease,
      value: languages.otherOphtalmologicDisease,
      imgUrl: cdn("/images/optic_illnesses/picto_other_eye.svg"),
    },
  ],
}

export const optic_illness: Question = {
  imgUrl: cdn("/images/allergie_illustration.svg"),
  title: languages.antecedents,
  id: PATH.optic_illness,
  multipleReplies: false,
  subquestion: optic_illness_details,
  replies: booleanSubReplies,
}

export const tutorial: Question = {
  id: PATH.tutorial,
  title: languages.demo,
  multipleReplies: false,
  replies: [],
  type: QUESTION_TYPE.redirect,
  value: TUTORIAL_OPTIC_PAGE,
}
